import Choice from '../../common/Choice';
import Input from '../../common/Input';
import Card from '../../common/Card';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactCalender from '../../common/Datepicker';
import { getPercentagePrice, getTaxExcludedPrice, getTaxIncludedPrice, getUnitPrice } from '../../../utils/helpers/formula';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchCompetitorStoresByStoreCode,
    fetchExpandSalesFloors,
    fetchPackingCategories,
    fetchSaleTypes,
} from '../../../redux/actions/api';
import { FRESHNESS_REASON_TYPE, REPORT_FLAG, TAX_INCLUDED_TYPE } from '../../../utils/constants/string';
import { ChangeRequestCompetitorCreateRequest } from '../../../services';
import { formattedDate, getRelativeDate, getSameDayOfNextMonth, isInDateRange, isWeekendSaleDay } from '../../../utils/helpers/date';
import { RequiredBadge } from '../../common/RequiredBadge';
import SelectSearch from '../../common/SelectSearch';
import { createCompetitorStoreOptionsWithoutChain } from '../../../utils/helpers/option';

const CardPriceSearch = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const storage = useSelector((state) => state.storage);
    const { isCompetitor, isFreshness, isInstruction } = storage;

    const {
        formData,
        setFormData,
        taxRate,
        capacityOfUnit,
        quantityOfUnit,
        discountedLowestSellingPrice,
        isRegistration,
        unit,
        taxIncludedType,
        setTaxIncludedType,
        isAllUnitSelected,
        isNearby,
    } = props;
    const constants = useSelector((state) => state.constants);
    const { expandSalesFloors, packingCategories, saleTypes, competitorStores } = constants;

    useEffect(() => {
        dispatch(fetchExpandSalesFloors());
        dispatch(fetchPackingCategories());
        dispatch(fetchSaleTypes());
        dispatch(fetchCompetitorStoresByStoreCode());
    }, [dispatch]);

    const [state, setState] = useState({
        discountedRequestSellingPrice: formData.discountedRequestSellingPrice || '',
        discountedRequestSellingPriceTax: '',
        sellingUnitPrice: '',
        sellingUnitPriceTax: '',
        salesStartDate: formData.salesStartDate || formattedDate(new Date()),
        salesEndDate: formData.salesEndDate || '',
        otherSpecialReports: formData.otherSpecialReports || '',
        expandSalesFloor: formData.expandSalesFloor || '',
        packingCategory: formData.packingCategory || '',
        otherPackingCategory: formData.otherPackingCategory || '',
        saleType: formData.saleType || '',
        otherSaleType: formData.otherSaleType || '',
        competitorStoreCode: formData.competitorStoreCode || '',

        discountRate: formData.discountRate || '',
        reportFlag: !!formData.reportFlag,
        freshnessReasonType: formData.freshnessReason === '賞味期限間近' ? '賞味期限間近' : 'その他',
        freshnessReason: formData.freshnessReason !== '賞味期限間近' ? formData.freshnessReason : '',
    });

    const {
        discountedRequestSellingPrice,
        discountedRequestSellingPriceTax,
        sellingUnitPrice,
        sellingUnitPriceTax,
        salesStartDate,
        salesEndDate,
        expandSalesFloor,
        packingCategory,
        saleType,
        otherSpecialReports,
        competitorStoreCode,

        discountRate,
        reportFlag,
        freshnessReasonType,
        freshnessReason,
    } = state;

    const [stateDataDatePicker, setStateDataDatePicker] = useState({
        minStartDate: new Date(),
        maxStartDate: null,
        minEndDate: new Date(),
        maxEndDate: new Date(new Date().setDate(new Date().getDate() + 7)),
    });
    const { minStartDate, maxStartDate, minEndDate, maxEndDate } = stateDataDatePicker;

    useEffect(() => {
        // salesEndDateを初期化
        if (salesStartDate > salesEndDate) {
            handleChangeInput('salesEndDate', '');
        }

        const today = new Date();
        const maxDate = new Date(today.getFullYear(), today.getMonth() + 2, 0);

        if (isFreshness) {
            const minStartDateFreshness = today;
            const maxStartDateFreshness = maxDate;

            // 開始日から1週間後まで選択可能
            const minEndDateFreshness = salesStartDate ? new Date(salesStartDate) : today;
            const relativeEndDateFreshness = getRelativeDate(salesStartDate, 7);
            const maxEndDateFreshness = salesStartDate && relativeEndDateFreshness < maxDate ? relativeEndDateFreshness : maxDate;
            if (salesEndDate) {
                if (!isInDateRange(new Date(salesEndDate), minEndDateFreshness, maxEndDateFreshness)) {
                    handleChangeInput('salesEndDate', '');
                }
            }
            setStateDataDatePicker({
                minStartDate: minStartDateFreshness,
                maxStartDate: maxStartDateFreshness,
                minEndDate: minEndDateFreshness,
                maxEndDate: maxEndDateFreshness,
            });
        } else {
            switch (saleType) {
                case ChangeRequestCompetitorCreateRequest.saleType.DAILY:
                    const minStartDateDaily = today;
                    const maxStartDateDaily = isInstruction ? getRelativeDate(today, 1) : maxDate;

                    // 開始日と翌日のみ選択可能
                    const minEndDateDaily = salesStartDate ? new Date(salesStartDate) : today;
                    const relativeEndDateDaily = getRelativeDate(salesStartDate, 1);
                    const maxEndDateDaily = salesStartDate && relativeEndDateDaily < maxDate ? relativeEndDateDaily : maxDate;
                    if (salesEndDate) {
                        if (!isInDateRange(new Date(salesEndDate), minEndDateDaily, maxEndDateDaily)) {
                            handleChangeInput('salesEndDate', '');
                        }
                    }

                    setStateDataDatePicker({
                        minStartDate: minStartDateDaily,
                        maxStartDate: maxStartDateDaily,
                        minEndDate: minEndDateDaily,
                        maxEndDate: maxEndDateDaily,
                    });
                    break;
                case ChangeRequestCompetitorCreateRequest.saleType.WEEKLY:
                    const minStartDateWeekly = today;
                    const maxStartDateWeekly = isInstruction ? getRelativeDate(today, 1) : maxDate;

                    // 開始日から1週間後まで選択可能
                    const minEndDateWeekly = salesStartDate ? new Date(salesStartDate) : today;
                    const relativeEndDateWeekly = getRelativeDate(salesStartDate, 7);
                    const maxEndDateWeekly = salesStartDate && relativeEndDateWeekly < maxDate ? relativeEndDateWeekly : maxDate;
                    if (salesEndDate) {
                        if (!isInDateRange(new Date(salesEndDate), minEndDateWeekly, maxEndDateWeekly)) {
                            handleChangeInput('salesEndDate', '');
                        }
                    }

                    setStateDataDatePicker({
                        minStartDate: minStartDateWeekly,
                        maxStartDate: maxStartDateWeekly,
                        minEndDate: minEndDateWeekly,
                        maxEndDate: maxEndDateWeekly,
                    });
                    break;
                case ChangeRequestCompetitorCreateRequest.saleType.WEEKEND:
                    const minStartDateWeekend = today;
                    const maxStartDateWeekend = maxDate;

                    // 開始日から3日間選択可能（週末でない場合はDatepickerで無効化）
                    const minEndDateWeekend = salesStartDate ? new Date(salesStartDate) : today;
                    const relativeEndDateWeekend = getRelativeDate(salesStartDate, 3);
                    const maxEndDateWeekend = salesStartDate && relativeEndDateWeekend < maxDate ? relativeEndDateWeekend : maxDate;
                    // salesEndDateが範囲外、または金、土、日でなければ初期化
                    if (salesEndDate) {
                        if (
                            !isInDateRange(new Date(salesEndDate), minEndDateWeekend, maxEndDateWeekend) ||
                            !isWeekendSaleDay(salesEndDate)
                        ) {
                            handleChangeInput('salesEndDate', '');
                        }
                    }
                    // salesStartDateが金、土、日でなければ初期化
                    if (salesStartDate && !isWeekendSaleDay(salesStartDate)) {
                        handleChangeInput('salesStartDate', '');
                    }
                    setStateDataDatePicker({
                        minStartDate: minStartDateWeekend,
                        maxStartDate: maxStartDateWeekend,
                        minEndDate: minEndDateWeekend,
                        maxEndDate: maxEndDateWeekend,
                    });
                    break;
                case ChangeRequestCompetitorCreateRequest.saleType.MONTHLY:
                    const minStartDateMonthly = today;
                    const maxStartDateMonthly = isInstruction ? getRelativeDate(today, 1) : maxDate;

                    // 開始日の翌月同日まで選択可能
                    const minEndDateMonthly = salesStartDate ? new Date(salesStartDate) : today;
                    const maxEndDateMonthly = salesStartDate ? getSameDayOfNextMonth(salesStartDate) : maxDate;
                    if (salesEndDate) {
                        if (!isInDateRange(new Date(salesEndDate), minEndDateMonthly, maxEndDateMonthly)) {
                            handleChangeInput('salesEndDate', '');
                        }
                    }
                    setStateDataDatePicker({
                        minStartDate: minStartDateMonthly,
                        maxStartDate: maxStartDateMonthly,
                        minEndDate: minEndDateMonthly,
                        maxEndDate: maxEndDateMonthly,
                    });
                    break;
                case ChangeRequestCompetitorCreateRequest.saleType.OTHER:
                    const minStartDateOther = today;
                    const maxStartDateOther = isInstruction ? getRelativeDate(today, 1) : maxDate;

                    // 開始日から14日以内
                    const minEndDateOther = salesStartDate ? new Date(salesStartDate) : today;
                    const relativeEndDateOther = getRelativeDate(salesStartDate, 14);
                    const maxEndDateOther = salesStartDate && relativeEndDateOther < maxDate ? relativeEndDateOther : maxDate;
                    if (salesEndDate) {
                        if (!isInDateRange(new Date(salesEndDate), minEndDateOther, maxEndDateOther)) {
                            handleChangeInput('salesEndDate', '');
                        }
                    }
                    setStateDataDatePicker({
                        minStartDate: minStartDateOther,
                        maxStartDate: maxStartDateOther,
                        minEndDate: minEndDateOther,
                        maxEndDate: maxEndDateOther,
                    });
                    break;
                default:
                    break;
            }
        }
    }, [saleType, salesStartDate]);

    useEffect(() => {
        handleSellingPriceChange('discountedRequestSellingPrice', discountedRequestSellingPrice);
    }, []);

    const handleSellingPriceChange = (field, value, isKeyUp = false) => {
        //init value blank
        let valueInput = String(value);

        switch (field) {
            case 'discountedRequestSellingPrice':
                calculateRequestSellingPriceTax(valueInput, isKeyUp);
                break;
            case 'discountedRequestSellingPriceTax':
                calculateRequestSellingPrice(valueInput, isKeyUp);
                break;
            case 'discountRate':
                if (valueInput.match(/^[0-9]+$/)) {
                    const discountedRequestSellingPrice = getPercentagePrice(discountedLowestSellingPrice, valueInput);
                    valueInput = String(discountedRequestSellingPrice);
                    calculateRequestSellingPriceTax(valueInput);
                }
                if (valueInput === '') {
                    // 割引率が未入力となった場合は初期化
                    calculateRequestSellingPriceTax('');
                }
                break;
            default:
                break;
        }
    };

    const calculateRequestSellingPriceTax = (valueInput, isKeyUp) => {
        let sellingPrice = '';
        let sellingUnitPrice = '';
        let discountedRequestSellingPriceTaxVal = '';
        let sellingUnitPriceTaxVal = '';

        if (valueInput.match(/^[0-9]+$/)) {
            sellingPrice = valueInput;
            sellingUnitPrice = getUnitPrice(sellingPrice, capacityOfUnit, quantityOfUnit);
            discountedRequestSellingPriceTaxVal = getTaxIncludedPrice(sellingPrice, taxRate);
            sellingUnitPriceTaxVal = getUnitPrice(discountedRequestSellingPriceTaxVal, capacityOfUnit, quantityOfUnit);
        }
        setState((prevState) => ({
            ...prevState,
            ...(!isKeyUp && { discountedRequestSellingPrice: sellingPrice }),
            sellingUnitPrice: sellingUnitPrice,
            discountedRequestSellingPriceTax: discountedRequestSellingPriceTaxVal,
            sellingUnitPriceTax: sellingUnitPriceTaxVal,
        }));
        setFormData((prevState) => ({
            ...prevState,
            discountedRequestSellingPrice: sellingPrice,
        }));
    };

    const calculateRequestSellingPrice = (valueInput, isKeyUp) => {
        let sellingUnitPriceVal = '';
        let sellingPriceVal = '';
        let sellingUnitPriceTaxVal = '';
        let discountedRequestSellingPriceTax = '';

        if (valueInput.match(/^[0-9]+$/)) {
            discountedRequestSellingPriceTax = valueInput;
            sellingUnitPriceTaxVal = getUnitPrice(discountedRequestSellingPriceTax, capacityOfUnit, quantityOfUnit);
            sellingPriceVal = getTaxExcludedPrice(discountedRequestSellingPriceTax, taxRate);
            sellingUnitPriceVal = getUnitPrice(sellingPriceVal, capacityOfUnit, quantityOfUnit);
        }
        setState((prevState) => ({
            ...prevState,
            discountedRequestSellingPrice: sellingPriceVal,
            sellingUnitPrice: sellingUnitPriceVal,
            ...(!isKeyUp && { discountedRequestSellingPriceTax: discountedRequestSellingPriceTax }),
            sellingUnitPriceTax: sellingUnitPriceTaxVal,
        }));
        setFormData((prevState) => ({
            ...prevState,
            discountedRequestSellingPrice: sellingPriceVal,
        }));
    };

    const handleChangeInput = (field, value) => {
        if (formData[field] !== undefined) {
            setFormData((prevState) => ({ ...prevState, [field]: value }));
        }
        if (field === 'otherPackingCategory' || field === 'otherSaleType') {
            setFormData((formData) => ({
                ...formData,
                [field]: value,
            }));
        }
        if (field === 'freshnessReasonType') {
            if (value === '賞味期限間近') {
                setFormData((formData) => ({
                    ...formData,
                    freshnessReason: '賞味期限間近',
                }));
            } else {
                setFormData((formData) => ({
                    ...formData,
                    freshnessReason: freshnessReason,
                }));
            }
        }
        setState((prevState) => ({ ...prevState, [field]: value }));
    };

    return (
        <div className="okc-card okc-result-form">
            <Card type="modal_card">
                {isCompetitor && !isNearby && !isRegistration && (
                    // 競合店選択
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p>{t('card_registration.competitor_store_name')}</p>
                        </div>
                        <div className="col-lg-7 offset-lg-1 flex-column">
                            <SelectSearch
                                placeholder={t('price_registration.search_form.survey.placeholder')}
                                onChange={(target) => {
                                    handleChangeInput('competitorStoreCode', target.value);
                                }}
                                options={createCompetitorStoreOptionsWithoutChain(competitorStores)}
                                value={competitorStoreCode}
                            />
                        </div>
                    </div>
                )}
                {(isCompetitor || isInstruction) && (
                    // 売場展開
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p>{t('card_registration.sales_floor_development')}</p>
                        </div>
                        <div className="col-lg-7 offset-lg-1 flex-column">
                            <div className="row no-gutters w-100">
                                <div className="form-check col-lg-2 pr-lg-3">
                                    <Choice
                                        id="expandSalesFloor"
                                        column="col-xl-3 col-lg-4 col-md-5"
                                        type="radio"
                                        data={expandSalesFloors || []}
                                        onChange={(value) => handleChangeInput('expandSalesFloor', value[0])}
                                        checked={expandSalesFloor}
                                        value={expandSalesFloor || ''}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {
                    // 売価
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p>
                                売価
                                <RequiredBadge />
                            </p>
                        </div>
                        <div className="col-lg-7 offset-lg-1 flex-column">
                            <div className="row no-gutters w-100 mb-3">
                                <div className="form-check col-lg-2 pr-lg-3">
                                    <Choice
                                        id="taxIncludedType"
                                        column="col-xl-3 col-lg-4 col-md-5"
                                        type="radio"
                                        data={TAX_INCLUDED_TYPE}
                                        onChange={(value) => setTaxIncludedType(value[0])}
                                        checked={taxIncludedType}
                                        value={taxIncludedType || ''}
                                    />
                                </div>
                            </div>
                            {isRegistration ? (
                                <>
                                    <div className="row no-gutters w-100 flex-xl-nowrap">
                                        <div className="col-xl-6 align-items-start mb-2 mb-xl-0 d-flex flex-column">
                                            <p className="mb-2">{t('card_registration.price.excluding_tax.title')}</p>
                                            <div className="row no-gutters w-100 flex-xl-nowrap">
                                                <div className="col-4 flex-column">
                                                    <Input
                                                        className="form-control form-control--input input__price"
                                                        name="discountedRequestSellingPrice"
                                                        type="text"
                                                        placeholder="売価"
                                                        autocomplete="off"
                                                        maxLength="6"
                                                        onChange={(value) => handleChangeInput('discountedRequestSellingPrice', value)}
                                                        onKeyUp={(value) =>
                                                            handleSellingPriceChange('discountedRequestSellingPrice', value, true)
                                                        }
                                                        onBlur={(value) => handleSellingPriceChange('discountedRequestSellingPrice', value)}
                                                        value={discountedRequestSellingPrice || ''}
                                                        disabled={discountRate || taxIncludedType === 'included'}
                                                    />
                                                </div>
                                                <div className="col-1 align-items-start">
                                                    <p className="m-0 w-100 text-center mt-2">{t('card_fresshness_registration.circle')}</p>
                                                </div>
                                            </div>
                                            <p className="my-2">{t('card_registration.price.excluding_tax.unit_title')}</p>
                                            <div className="row no-gutters w-100 flex-xl-nowrap">
                                                <div className="col-4 flex-column">
                                                    <Input
                                                        className="form-control form-control--input form-control--readonly result__price"
                                                        name="sellingUnitPrice"
                                                        type="text"
                                                        placeholder={t('card_registration.placeholder.unit_price')}
                                                        readonly="readonly"
                                                        autocomplete="off"
                                                        onChange={(value) => handleChangeInput('sellingUnitPrice', value)}
                                                        value={isAllUnitSelected ? '-' : sellingUnitPrice || ''}
                                                        disabled
                                                    />
                                                </div>
                                                <div className="col-1 align-items-start">
                                                    <p className="m-0 w-100 text-center mt-2">{t('card_registration.circle')}</p>
                                                </div>
                                                <div className="col-4 flex-column">
                                                    <Input
                                                        className="form-control form-control--input form-control--readonly result__price"
                                                        name="unit"
                                                        type="text"
                                                        readonly="readonly"
                                                        autocomplete="off"
                                                        value={isAllUnitSelected ? '-' : `${quantityOfUnit} ${unit}`}
                                                        disabled
                                                    />
                                                </div>
                                                <div className="col-auto align-items-start"></div>
                                                <div className="col-1"></div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 align-items-start mb-2 mb-xl-0 d-flex flex-column">
                                            <p className="mb-2">{t('card_registration.price.including_tax.title')}</p>
                                            <div className="row w-100 flex-xl-nowrap">
                                                <div className="col-4 flex-column">
                                                    <Input
                                                        className="form-control form-control--input form-control--readonly input__tax-price"
                                                        type="text"
                                                        name="discountedRequestSellingPriceTax"
                                                        placeholder="売価"
                                                        readonly="readonly"
                                                        autocomplete="off"
                                                        maxLength="6"
                                                        disabled={discountRate || taxIncludedType === 'excluded' || !taxIncludedType}
                                                        onChange={(value) => handleChangeInput('discountedRequestSellingPriceTax', value)}
                                                        onKeyUp={(value) =>
                                                            handleSellingPriceChange('discountedRequestSellingPriceTax', value, true)
                                                        }
                                                        onBlur={(value) =>
                                                            handleSellingPriceChange('discountedRequestSellingPriceTax', value)
                                                        }
                                                        value={discountedRequestSellingPriceTax || ''}
                                                    />
                                                </div>
                                                <div className="col-1 align-items-start">
                                                    <p className="m-0 w-100 text-center mt-2">{t('card_fresshness_registration.circle')}</p>
                                                </div>
                                            </div>
                                            <p className="my-2">{t('card_registration.price.including_tax.unit_title')}</p>
                                            <div className="row w-100 flex-xl-nowrap">
                                                <div className="col-4 flex-column">
                                                    <Input
                                                        className="form-control form-control--input form-control--readonly result__tax-price"
                                                        type="text"
                                                        name="sellingUnitPriceTax"
                                                        placeholder={t('card_registration.placeholder.unit_price')}
                                                        readonly="readonly"
                                                        autocomplete="off"
                                                        onChange={(value) => handleChangeInput('sellingUnitPriceTax', value)}
                                                        value={isAllUnitSelected ? '-' : sellingUnitPriceTax || ''}
                                                        disabled
                                                    />
                                                </div>
                                                <div className="col-1 align-items-start">
                                                    <p className="m-0 w-100 text-center mt-2">{t('card_registration.circle')}</p>
                                                </div>
                                                <div className="col-4 flex-column">
                                                    <Input
                                                        className="form-control form-control--input form-control--readonly result__tax-price"
                                                        type="text"
                                                        name="unitTax"
                                                        readonly="readonly"
                                                        autocomplete="off"
                                                        value={isAllUnitSelected ? '-' : `${quantityOfUnit} ${unit}`}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="row no-gutters w-100 flex-xl-nowrap">
                                        <div className="col-xl-6 align-items-start mb-2 mb-xl-0 d-flex flex-column">
                                            <p className="mb-2">{t('card_registration.price.excluding_tax.title')}</p>
                                            <div className="row no-gutters w-100 flex-xl-nowrap">
                                                <div className="col-4 flex-column">
                                                    <Input
                                                        className="form-control form-control--input input__price"
                                                        name="discountedRequestSellingPrice"
                                                        type="text"
                                                        placeholder="売価"
                                                        autocomplete="off"
                                                        maxLength="6"
                                                        onChange={(value) => handleChangeInput('discountedRequestSellingPrice', value)}
                                                        onKeyUp={(value) =>
                                                            handleSellingPriceChange('discountedRequestSellingPrice', value, true)
                                                        }
                                                        onBlur={(value) => handleSellingPriceChange('discountedRequestSellingPrice', value)}
                                                        value={discountedRequestSellingPrice || ''}
                                                        disabled={discountRate || taxIncludedType === 'included'}
                                                    />
                                                </div>
                                                <div className="col-1 align-items-start">
                                                    <p className="m-0 w-100 text-center mt-2">{t('card_fresshness_registration.circle')}</p>
                                                </div>
                                            </div>
                                            <p className="my-2">{t('card_registration.price.excluding_tax.unit_title')}</p>
                                            <div className="row no-gutters w-100 flex-xl-nowrap">
                                                <div className="col-4 flex-column">
                                                    <Input
                                                        className="form-control form-control--input form-control--readonly result__price"
                                                        name="sellingUnitPrice"
                                                        type="text"
                                                        placeholder={t('card_registration.placeholder.unit_price')}
                                                        readonly="readonly"
                                                        autocomplete="off"
                                                        onChange={(value) => handleChangeInput('sellingUnitPrice', value)}
                                                        value={isAllUnitSelected ? '-' : sellingUnitPrice || ''}
                                                        disabled
                                                    />
                                                </div>
                                                <div className="col-2 align-items-start">
                                                    <p className="m-0 w-100 text-center mt-2">{t('card_registration.circle')}</p>
                                                </div>
                                                <div className="col-4 flex-column">
                                                    <Input
                                                        className="form-control form-control--input form-control--readonly result__price"
                                                        name="unit"
                                                        type="text"
                                                        readonly="readonly"
                                                        autocomplete="off"
                                                        value={isAllUnitSelected ? '-' : `${quantityOfUnit} ${unit}`}
                                                        disabled
                                                    />
                                                </div>
                                                <div className="col-auto align-items-start"></div>
                                                <div className="col-1"></div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 align-items-start mb-2 mb-xl-0 d-flex flex-column">
                                            <p className="mb-2">{t('card_registration.price.including_tax.title')}</p>
                                            <div className="row w-100 flex-xl-nowrap">
                                                <div className="col-4 flex-column">
                                                    <Input
                                                        className="form-control form-control--input form-control--readonly input__tax-price"
                                                        type="text"
                                                        name="discountedRequestSellingPriceTax"
                                                        placeholder="売価"
                                                        readonly="readonly"
                                                        autocomplete="off"
                                                        maxLength="6"
                                                        disabled={discountRate || taxIncludedType === 'excluded' || !taxIncludedType}
                                                        onChange={(value) => handleChangeInput('discountedRequestSellingPriceTax', value)}
                                                        onKeyUp={(value) =>
                                                            handleSellingPriceChange('discountedRequestSellingPriceTax', value, true)
                                                        }
                                                        onBlur={(value) =>
                                                            handleSellingPriceChange('discountedRequestSellingPriceTax', value)
                                                        }
                                                        value={discountedRequestSellingPriceTax || ''}
                                                    />
                                                </div>
                                                <div className="col-1 align-items-start">
                                                    <p className="m-0 w-100 text-center mt-2">{t('card_fresshness_registration.circle')}</p>
                                                </div>
                                            </div>
                                            <p className="my-2">{t('card_registration.price.including_tax.unit_title')}</p>
                                            <div className="row w-100 flex-xl-nowrap">
                                                <div className="col-4 flex-column">
                                                    <Input
                                                        className="form-control form-control--input form-control--readonly result__tax-price"
                                                        type="text"
                                                        name="sellingUnitPriceTax"
                                                        placeholder={t('card_registration.placeholder.unit_price')}
                                                        readonly="readonly"
                                                        autocomplete="off"
                                                        onChange={(value) => handleChangeInput('sellingUnitPriceTax', value)}
                                                        value={isAllUnitSelected ? '-' : sellingUnitPriceTax || ''}
                                                        disabled
                                                    />
                                                </div>
                                                <div className="col-2 align-items-start">
                                                    <p className="m-0 w-100 text-center mt-2">{t('card_registration.circle')}</p>
                                                </div>
                                                <div className="col-4 flex-column">
                                                    <Input
                                                        className="form-control form-control--input form-control--readonly result__tax-price"
                                                        type="text"
                                                        name="unitTax"
                                                        readonly="readonly"
                                                        autocomplete="off"
                                                        value={isAllUnitSelected ? '-' : `${quantityOfUnit} ${unit}`}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                }
                {isFreshness && (
                    // 割引率適用
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p>{t('card_fresshness_registration.discount_rate_application')}</p>
                        </div>
                        <div className="col-lg-7 offset-lg-1 flex-column">
                            <div className="row no-gutters w-100 flex-xl-nowrap">
                                <div className="col-xl-6 align-items-start mb-2 mb-xl-0 d-flex flex-column">
                                    <div className="row no-gutters w-100 flex-xl-nowrap">
                                        <div className="col-4 flex-column">
                                            <Input
                                                className="form-control form-control--input"
                                                value={discountRate || ''}
                                                type="text"
                                                autocomplete="off"
                                                maxLength="6"
                                                onChange={(value) => {
                                                    handleSellingPriceChange('discountRate', value);
                                                    handleChangeInput('discountRate', value);
                                                }}
                                                disabled={!discountRate && !!discountedRequestSellingPrice}
                                            />
                                        </div>
                                        <div className="col-2 align-items-start">
                                            <p className="m-0 w-100 text-center mt-2">
                                                {t('card_fresshness_registration.percent_discount')}
                                            </p>
                                        </div>
                                        <div className="col-4 flex-column">
                                            <Input
                                                className="form-control form-control--input form-control--readonly"
                                                type="text"
                                                value={discountRate ? discountedRequestSellingPrice : ''}
                                                placeholder={t('card_fresshness_registration.placeholder.discount_rate')}
                                                readonly="readonly"
                                                autocomplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="col-2 align-items-start">
                                            <p className="m-0 w-100 mt-2">&nbsp;{t('card_fresshness_registration.circle')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {(isCompetitor || isInstruction) && (
                    // 販売方法・荷姿
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p>{t('card_registration.sales_conditions')}</p>
                        </div>
                        <div className="col-lg-7 offset-lg-1 flex-column">
                            <div className="row w-100">
                                <Choice
                                    id="packingCategory"
                                    column="col-sm-3"
                                    type="radio"
                                    data={packingCategories || []}
                                    onChange={(value) => handleChangeInput('packingCategory', value[0])}
                                    checked={packingCategory || ''}
                                    value={packingCategory || ''}
                                />
                            </div>
                        </div>
                        <div className="col-7 offset-4 mt-2">
                            <Input
                                className="form-control form-control--input packingCategoryOtherInput"
                                type="text"
                                name="otherPackingCategory"
                                maxLength="60"
                                placeholder={t('card_registration.placeholder.other_input_fields')}
                                autocomplete="off"
                                onChange={(value) => handleChangeInput('otherPackingCategory', value)}
                                disabled={packingCategory !== 'OTHER'}
                            />
                        </div>
                    </div>
                )}
                {(isCompetitor || isInstruction) && (
                    // 特売種別・期間
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p>{t('card_registration.sale_type')}</p>
                        </div>
                        <div className="col-lg-7 offset-lg-1 flex-column">
                            <div className="row w-100">
                                <Choice
                                    id="saleType"
                                    column="col-sm-4"
                                    type="radio"
                                    data={saleTypes || []}
                                    onChange={(value) => {
                                        handleChangeInput('saleType', value[0]);
                                        handleChangeInput('salesEndDate', '');
                                    }}
                                    checked={saleType}
                                    value={saleType || ''}
                                />
                            </div>
                        </div>
                        <div className="col-7 offset-4 mt-2">
                            <Input
                                className="form-control form-control--input saleTypeOtherInput"
                                id="valueInput"
                                type="text"
                                maxLength="60"
                                placeholder={t('card_registration.placeholder.other_input_fields')}
                                onChange={(value) => handleChangeInput('otherSaleType', value)}
                                disabled={saleType !== 'OTHER'}
                            />
                        </div>
                    </div>
                )}
                {
                    // 開始日 ～ 終了日
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p>
                                {t('card_registration.date')}
                                <RequiredBadge />
                            </p>
                        </div>
                        <div className="col-5 col-lg-3 offset-lg-1 flex-column align-items-start">
                            <ReactCalender
                                classNameInputDateTime="js-datepicker salesStartDate"
                                onChange={(value) => handleChangeInput('salesStartDate', value)}
                                value={salesStartDate}
                                placeholder={t('card_registration.placeholder.start_date')}
                                minDate={minStartDate}
                                maxDate={maxStartDate}
                                isWeekend={saleType === 'WEEKEND'}
                            />
                        </div>
                        <div className="col-2 col-lg-1">
                            <p className="m-0 w-100 text-center">～</p>
                        </div>
                        <div className="col-5 col-lg-3 flex-column align-items-start">
                            <ReactCalender
                                classNameInputDateTime="js-datepicker salesEndDate"
                                onChange={(value) => handleChangeInput('salesEndDate', value)}
                                value={salesEndDate}
                                placeholder={t('card_registration.placeholder.end_date')}
                                minDate={minEndDate}
                                maxDate={maxEndDate}
                                isWeekend={saleType === 'WEEKEND'}
                            />
                        </div>
                    </div>
                }
                {isFreshness && (
                    // バイヤー報告
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p>{t('card_fresshness_registration.report_flg')}</p>
                        </div>
                        <div className="col-lg-7 offset-lg-1 flex-column pt-2">
                            <div className="row no-gutters w-100 mb-3 flex-xl-nowrap">
                                <Choice
                                    id="reportFlag"
                                    className="form-check-input"
                                    column="col-sm-4"
                                    type="radio"
                                    data={REPORT_FLAG}
                                    onChange={(value) => handleChangeInput('reportFlag', value[0] === '1')}
                                    checked={[reportFlag ? '1' : '0']}
                                    value={reportFlag ? '1' : '0'}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {isFreshness && (
                    // 鮮度起因値下げ理由
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p>{t('card_fresshness_registration.freshness_reason')}</p>
                        </div>
                        <div className="col-lg-7 offset-lg-1 flex-column">
                            <div className="row no-gutters w-100 mb-3 flex-xl-nowrap">
                                <Choice
                                    id="freshnessReasonType"
                                    className="form-check-input"
                                    column="col-sm-4"
                                    type="radio"
                                    data={FRESHNESS_REASON_TYPE}
                                    onChange={(value) => handleChangeInput('freshnessReasonType', value[0])}
                                    checked={[freshnessReasonType || '']}
                                    value={freshnessReasonType || ''}
                                />
                            </div>
                            <div className="row no-gutters w-100 flex-xl-nowrap">
                                <div className="col-xl-12 align-items-start flex-column">
                                    <div className="form-textarea">
                                        <Input
                                            type="textarea"
                                            className="form-control form-control--input"
                                            maxLength="100"
                                            placeholder={t('card_fresshness_registration.placeholder.freshness_reason')}
                                            onChange={(value) => handleChangeInput('freshnessReason', value)}
                                            value={freshnessReason || ''}
                                            disabled={freshnessReasonType === '賞味期限間近'}
                                        />
                                        <div className="form-textarea__divider"></div>
                                    </div>
                                    {freshnessReasonType === 'その他' && !freshnessReason && (
                                        <p className="okc-error mt-2 mb-0 freshnessReasonError">
                                            {t('card_fresshness_registration.validate.freshness_reason')}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {
                    // その他特記事項
                    <div className="row okc-card__row">
                        <div className="col-lg-3 okc-result-form__title">
                            <p>{t('card_registration.other_noteworthy_things')}</p>
                        </div>
                        <div className="col-lg-7 offset-lg-1">
                            <div className="form-textarea">
                                <Input
                                    type="textarea"
                                    className="form-control otherSpecialReports"
                                    maxLength="100"
                                    placeholder={t('card_registration.placeholder.other_note_input_fields')}
                                    onChange={(value) => handleChangeInput('otherSpecialReports', value)}
                                    value={otherSpecialReports || ''}
                                />
                                <div className="form-textarea__divider"></div>
                            </div>
                        </div>
                    </div>
                }
            </Card>
        </div>
    );
};

export default CardPriceSearch;
